'use client';

import { useState } from 'react';
import Image from 'next/image';
import TextField from '../ContactsBlock/components/Text-fild/Text-fild';
import ButtonSimple from '../HeroBlock/components/ButtonSimple/ButtonSimple';
import styles from './loginComponent.module.scss';
import {
  LoginComponentProps,
  loginFormData,
  loginFormErrors,
} from '@/types/loginComponent.types';

const LoginComponent = ({ setCurrentComponent }: LoginComponentProps) => {
  const [formData, setFormData] = useState<loginFormData>({
    email: '',
    password: '',
  });

  const [errors, setErrors] = useState<loginFormErrors>({});

  const validateForm = (): boolean => {
    const newErrors: loginFormErrors = {};

    // Email validation
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }

    // Password validation
    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (field: keyof loginFormData) => (value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (validateForm()) {
      console.log('Form submitted with data:', formData);
    } else {
      console.log('Form has errors:', errors);
    }
  };

  return (
    <>
      <div className={`${styles.loginComponent}`}>
        <h2 className={`${styles.loginComponentTitle}`}>
          Login or create an account
        </h2>
        <div className={`${styles.loginForm}`}>
          <form onSubmit={handleSubmit}>
            <div className={`${styles.loginFormTitle}`}>
              Fill in the fields to register
            </div>
            <TextField
              label="Email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange('email')}
              error={errors.email}
            />
            <div className={`${styles.loginFormPasswordWrapper}`}>
              <TextField
                label="Password"
                placeholder="Enter your Password"
                value={formData.password}
                onChange={handleChange('password')}
                error={errors.password}
              />
            </div>

            <div onClick={handleSubmit}>
              <ButtonSimple
                className={styles.submitButton}
                color="accent"
                highContrast
                loading={false}
                size={3}
                state="default ✦"
                variant="solid ✦"
                text="Login"
                iconStart={false}
                iconEnd={false}
                focusRing={false}
                fullWidth={true}
                designBlendingMode="/design--blendingmode1.svg"
                designBlendingMode1="/design--blendingmode1.svg"
              />
            </div>
          </form>
          <div className={`${styles.loginFormBottom}`}>
            <p className={`${styles.loginFormBottomText}`}>Or continue with</p>

            <div className={`${styles.bottomBtnsWrapper}`}>
              <button className={`${styles.bottomBtn}`}>
                <Image
                  src="/img/loginPage/google.svg"
                  alt="google"
                  width={77}
                  height={20}
                />
              </button>
              <button className={`${styles.bottomBtn}`}>
                <Image
                  src="/img/loginPage/apple.svg"
                  alt="apple"
                  width={77}
                  height={20}
                />
              </button>
            </div>
          </div>
        </div>

        <div className={styles.loginFormSubFormWrapper}>
          <p className={styles.loginFormSubFormText}>
            Don&apos;t have an account?
          </p>
          <button
            className={styles.signUpLinck}
            onClick={() => setCurrentComponent(2)}
          >
            Sign Up
          </button>
        </div>
      </div>
    </>
  );
};

export default LoginComponent;
